/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

const cookieParser = (cookies: string): Record<string, string | undefined> => (
  cookies.split(';').reduce((acc, cookie) => {
    const [key, value] = cookie.split('=');
    return { ...acc, [key.trim()]: value };
  }, {})
);

export class GTMSession {
  public measurementId: string;

  constructor(measurementId: string) {
    this.measurementId = measurementId;
  }

  public get clientId(): string | undefined {
    if (!this.isStarted()) return undefined;
    const cookies = cookieParser(document.cookie);
    return cookies._ga;
  }

  public get sessionId(): string | undefined {
    if (!this.isStarted()) return undefined;
    const cookies = cookieParser(document.cookie);
    return cookies[`_ga_${this.measurementId}`];
  }

  private isStarted(): boolean {
    return Boolean(window?.dataLayer?.find?.(layer => layer['gtm.start']));
  }
}

